import { crudActions } from '../factories'

export const { find, setList, clearList, get } = crudActions({ name: 'customReports' })
